<template>
  <div class="hero-outer-container">
    <HeroContainer/>
  </div>
  <h1 class="bemutatkozas" id="bemutatkozas">Csak annyi napfény, amennyit mi engedünk be.</h1>
  <h4>Árnyékolástechnika Veszprém és környékén</h4>
  <div class="mb-5">
    <h5>Minden, ami árnyékolás!</h5>
    <h5>A kisebb javításoktól (Gurtnicsere, Leszakadt redőny, Szúnyoghálók háló cseréje),</h5>
    <h5>az új beépítéseken át (Szúnyogháló, Műanyag Redőny, Alumínium Motoros Redőny, Reluxa, Roletta, Pliszé),</h5>
    <h5>a nagyobb, kerti árnyékolókig (Napellenző, Ponyvás pergola, Télikert árnyékoló, Napháló).</h5>
  </div>
  <div class="px-4 d-flex justify-content-around flex-wrap">
    <ProsList :items='pros' :iconClass='iconClass'/>
    <CdnImage 
      classes="cont-img cont-img-w shadow" 
      src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/woman-window"
      fallbackSrc="./static/assets/contractor.png"
      alt="Gurtnicsere, redőnyjavítás Veszprém és környékén - Árnyék Guru" />
  </div>
  <PhoneComponent/>
  <ServiceSelector/>
  <hr class="hr" />
  <h2 id="javitas"><i class="bi bi-tools"></i> Javítás/Szerelés <i class="bi bi-tools"></i></h2>
  <div class="px-2 mb-5 d-flex justify-content-around flex-wrap">
    <CdnImage 
      classes="fix-img" 
      src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/fixing-parts"
      fallbackSrc="./static/assets/gurtni.jpg"
      alt="Gurtnicsere, Leszakadt redőny, szúnyogháló csere Veszprém és környékén" />
    <ProsList :items='fix'/>
  </div>
  <ContactUsSection />
</template>

<script>
import ProsList from '@/components/ProsList.vue';
import HeroContainer from '../components/HeroContainer.vue';
import ServiceSelector from '../components/ServiceSelector.vue';
import PhoneComponent from '@/components/PhoneComponent.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import CdnImage from '@/components/CdnImage.vue';

export default {
  name: 'MainPage',
  data() {
    return {
      iconClass: 'bi bi-check-circle',
      componentKey: 0, // Unique key for the component
      pros: [
      'Több éves tapasztalat', 
      'Minőség', 
      'Megbízhatóság', 
      'Funkcionalitás', 
      'Ügyfélközpontúság', 
      'Kiváló ár-érték arány',
      'Rövid határidővel'
      ],
      fix: [
      'Gurtnicsere', 
      'Redőny javítás', 
      'Motoros redőny javítás',
      'Motorizálás', 
      'Szúnyoghálók háló cseréje', 
      'Napellenzők ponyva cseréje', 
      'Egyéb árnyékolók javítása',
      'Alkatrészek cseréje',
      'Rövid határidővel' 
      ],
    };
  },
  components: {
    HeroContainer,
    ProsList,
    ServiceSelector,
    PhoneComponent,
    ContactUsSection,
    CdnImage,
  }
}

</script>

<style scoped>
h1 {
  margin: 30px 0px 30px;
}

h2 {
  margin: 30px 0px 30px;
}

h3 {
  margin: 10px 0px 10px;
}

.half-width {
  width: 50%;
  margin: 30px 0px 30px;
  transition: all .2s ease-in-out;
}

.half-width:hover {
  transform: scale(1.05);
}

.hero-outer-container {
    height:500px;
    margin-top: 65px;
}

.cont-img {
  object-fit: cover;
  border-radius: 6px;
}

.cont-img-w {
  max-width: 40%;
  height: 300px;
}

.color-section {
  color: v-bind('color');
}


@media screen and (max-width: 800px) {
  .cont-img-w {
    max-width: 90%;
  }
  .hero-outer-container {
      height: 300px;
  }
}

.bemutatkozas {
  font-family: 'Amatic SC';
  font-size: 2.5rem;
  max-width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.fix-img {
  max-width: 80%;
}
</style>
